import { useTranslation } from 'react-i18next'
import Button from '@/components/ui/button'
import Link from '@/components/ui/link'

const HERO_IMAGE =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuBaTY2Yk_e5hrW1Mm0IsMT8sOmEtB4Kvs4hHi-JIuAtmgMrv8-mpe8kUn7gIBUwtes4NYDRMaZhaxAn6k9ZN6BavhczpWMG_P2-u3bjCTqPcKs6Uc-rPc-OLpKX6gtXbHOCTKQ9KlU5z4GcapMlJZ4a3EWwFlr7IKfJQV51sXakZFUnxxcDJeVjnkXrYNoksW9TP-bNaj-w0M_aAClBkiBO_oOOGVEM929g8eX_ipCS8x3gqZHy9HB2wUCTbC4rI84R5xaEgm51Si44'

export default function Hero() {
  const { t } = useTranslation()

  return (
    <section className="relative min-h-screen flex items-center pt-24 overflow-hidden">
      <div className="absolute inset-0 z-0 opacity-40">
        <div className="absolute inset-0 bg-linear-to-r from-surface via-surface/80 to-transparent z-10" />
        <img
          className="w-full h-full object-cover grayscale"
          src={HERO_IMAGE}
          alt="Monolithic modern skyscraper with dramatic upward perspective"
        />
      </div>

      <div className="relative z-20 max-w-[1440px] mx-auto px-5 sm:px-8 md:px-10 lg:px-12">
        <div
          className="animate-hero-reveal mb-6 md:mb-10 max-w-3xl"
          style={{ animationDelay: '0.1s' }}
        >
          <span className="text-primary font-body text-xs md:text-sm uppercase tracking-[0.3em] font-bold">
            {t('hero.kicker')}
          </span>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-8 items-center">
          <div className="col-span-12 lg:col-span-7">
            <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[0.9] text-on-surface">
              <span className="animate-hero-reveal block" style={{ animationDelay: '0.2s' }}>
                {t('hero.heading1')}
              </span>
              <span
                className="animate-hero-reveal text-primary bg-clip-text ml-4 md:ml-8 block"
                style={{ animationDelay: '0.5s' }}
              >
                {t('hero.heading2')}
              </span>
            </h1>
          </div>

          <div className="col-span-12 lg:col-span-5 lg:pl-12">
            <div className="w-12 h-1 bg-primary mb-6" />
            <p className="text-on-surface-variant text-md md:text-lg max-w-lg leading-relaxed">
              {t('hero.description')}
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 mt-8 md:mt-12">
          <Link href="/contact">
            <Button variant="gradient" size="md">
              {t('hero.cta')}
            </Button>
          </Link>
          <Link href="/manifesto">
            <Button variant="outline" size="md" className="group">
              {t('hero.manifesto')}{' '}
              <span className="inline-block transition-transform group-hover:translate-x-2 ml-2">
                →
              </span>
            </Button>
          </Link>
        </div>

        <div className="flex items-center gap-2 mt-10 md:mt-14 pt-6 md:pt-8 border-t border-outline-variant/20 max-w-2xl">
          <span className="material-symbols-outlined text-primary text-lg">
            network_intelligence
          </span>
          <span className="text-on-surface-variant text-sm md:text-base font-body">
            {t('hero.proof')}
          </span>
        </div>
      </div>
    </section>
  )
}
